export default "__VITE_ASSET__NIAigix1__"